import { BigIntWithDecimals, USD_DECIMALS } from "@silo/types";
import { parseBigIntWithDecimals } from "@silo/utils";

type CoinGeckoResponse = Record<string, { usd: number }>;

export const getCoinGeckoPriceUsd = async (
  id: string
): Promise<BigIntWithDecimals> => {
  const COIN_GECKO_KEY = process.env.COIN_GECKO_KEY;

  if (!COIN_GECKO_KEY) {
    throw new Error("COIN_GECKO_KEY is not set");
  }

  const response = await fetch(
    `https://pro-api.coingecko.com/api/v3/simple/price?ids=${id}&vs_currencies=usd`,
    {
      headers: {
        "x-cg-pro-api-key": COIN_GECKO_KEY,
      },
    }
  );

  const json = (await response.json()) as CoinGeckoResponse;

  const {
    [id]: { usd },
  } = json;

  return parseBigIntWithDecimals(USD_DECIMALS)(`${usd}`);
};
